import styled from 'styled-components'

export const ClientsWrapper = styled.div`
  position: relative;

  & > a:nth-child(3) {
    position: absolute;
    top: 42px;
    right: 0;
  }
`
